// Note that the file service does file API as well - this is because WebPack was being a 
// dick and not letting me work with an actual fileApi.js, it would not correctly import
// the API references
import moment from 'moment'
import apiBase from "./apiBase";
import axios from "axios";

async function uploadFile(fileName, folder, contentType, file) {
    // Generate a new file name with some time data
    var secureFileName = moment().format('YYMMDDHHmm') + '_' + file.name;

    var presignedURLResponse = await getUploadPresignedURL(secureFileName, folder, contentType);

    if (presignedURLResponse.status == 200) {
        // We got the upload, now upload
        var data = presignedURLResponse.data;

        var x = await uploadToS3(data.Url, file, contentType)

        if (x.status == 200) {
            return data.Path
        } else {
            throw new Error("There was an issue uploading the file, please try again later");
        }
    } else {
        throw new Error("There was an issue registering with the cloud, please try again later")
    }
}

export default {
    uploadFile,
    getDownloadURL,
    deleteFileAndDocument,
    uploadFileAndSaveDocument,
    uploadSignatureImage,
    getImageS3Path,
    uploadMedicalRecordImage,
    getMedicalRecordImageS3Path
}


// API Functions

async function getUploadPresignedURL(fileName, folderName, contentType) {
    return await apiBase.simpleGetAsync('/files', {
        params: {
            direction: "In",
            fileName,
            folderName,
            contentType
        }
    })
}

async function uploadToS3(presignedUrl, content, contentType) {
    return await axios.put(presignedUrl, content, {
        headers: { 'Content-Type': contentType },
    });
}


async function deleteFileAndDocument(filePath, VenomAnalysisID) {

    var result = await apiBase.simpleDeleteAsync("/document", VenomAnalysisID);
    return result;
}

async function getDownloadURL(filePath) {
    var response = await apiBase.simpleGetAsync('/files', {
        params: {
            direction: "Out",
            filePath
        }
    })

    return response.data;
}

/**
 * Helper function which will upload a file and then save the document entry into the associated database table
 * @param {*} document 
 * @param {*} fileName 
 * @param {*} folder 
 * @param {*} contentType 
 * @param {*} file 
 */
async function uploadFileAndSaveDocument(document, fileName, folder, contentType, file) {
    var path = await uploadFile(fileName, folder, contentType, file);

    document.S3Path = path;

    await apiBase.simplePostAsync("/document", document);
}

/**
 * Helper function which will upload an image and then save the image entry into the associated database table
 * @param {*} image 
 * @param {*} fileName 
 * @param {*} folder 
 * @param {*} contentType 
 * @param {*} file 
 */

async function uploadSignatureImage(image, fileName, folder, contentType, file) {
    var path = await uploadFile(fileName, folder, contentType, file);

    image.ImageS3Path = path;
    await apiBase.simplePostAsync("/signatureimage", image);
}

async function getImageS3Path(email) {

    const result = await apiBase.simpleGetAsync("/signatureimage", { params: { email } });
    const { data } = result;
    return data[0];
}


async function uploadMedicalRecordImage(image, fileName, folder, contentType, file) {
    var path = await uploadFile(fileName, folder, contentType, file);

    image.ImageS3Path = path;
    await apiBase.simplePostAsync("/medicalRecordImg", image);
}

async function getMedicalRecordImageS3Path(MedicalRecordID) {

    const result = await apiBase.simpleGetAsync("/medicalRecordImg", { params: { MedicalRecordID } });
    const { data } = result;
    return data[0];
}